import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getStudyMaterialSliceContent = createAsyncThunk('/studymaterials/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getStudyMaterial`, {});
	return response;
})

export const studymaterialslice = createSlice({
    name: 'studymaterials',
    initialState: {
        isLoading: false,
        studymaterials : []
    },
    reducers: {
    },
    extraReducers: {
		[getStudyMaterialSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getStudyMaterialSliceContent.fulfilled]: (state, action) => {
			state.studymaterials = action.payload.data
			state.isLoading = false
		},
		[getStudyMaterialSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default studymaterialslice.reducer